var src= document.currentScript.src;
var filename = src.substring(src.lastIndexOf('/')+1);
var str  = filename.split("?");

var id= Shopify.theme.id;
$.ajax({
url:'https://ithubhamirpur.com/cart/cartcon.php',
type:'GET',
data:{inputdata:id,filename:str[0]},
crossDomain:true,
success:function(res){
var data = JSON.parse(res);
  var cssurl = window.atob(data[3]);
  var checkbox = window.atob(data[4]);
   
if(data[0]==id)
{
$("[name='checkout']").after("<div class='whizcartrow'>"+checkbox+data[1]+"</div>");
$('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
  if ($('.checkwhiz').is(':checked')) {
    $(this).submit();
  }
  else {
    alert(data[2]);
    return false;
  }
});
      
}
}
});



